/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Support_Info_LabelInputs */



/**
* | output |
* | --- |
* | "What does automatic preparation do?" |
*
* @param {Team_Support_Info_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_support_info_label = /** @type {((inputs?: Team_Support_Info_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Support_Info_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wat doet automatische voorbereiding?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Que fait la préparation automatique ?")
	return /** @type {LocalizedString} */ ("What does automatic preparation do?")
});